import { Form, Grid, Text, TextField } from '@approvalmax/ui/src/components';
import { netSuiteConstants } from 'modules/common/constants';
import { useVendorTemplateFieldSettings } from 'pages/requestForm/containers/netsuite/hooks';
import {
    isFieldMandatory,
    isFieldVisible,
} from 'pages/requestForm/containers/netsuite/NetSuiteRequestForm/NetSuiteRequestForm.helpers';
import { memo } from 'react';

import { messages } from './ContactInformation.messages';

export const ContactInformation = memo(() => {
    const fieldSettings = useVendorTemplateFieldSettings();

    const hasContactInformationSection =
        isFieldVisible(fieldSettings.email) ||
        isFieldVisible(fieldSettings.phone) ||
        isFieldVisible(fieldSettings.altPhone) ||
        isFieldVisible(fieldSettings.fax);

    if (!hasContactInformationSection) {
        return null;
    }

    return (
        <Form.Part>
            <Text font='headline' fontSize='xxsmall' fontWeight='medium' color='midnight80' spacing='20 0'>
                {messages.contactInformationSection}
            </Text>

            <Grid gridTemplateColumns='1fr 1fr' gap={16}>
                {isFieldVisible(fieldSettings.email) && (
                    <TextField
                        label={messages.email}
                        required={isFieldMandatory(fieldSettings.email)}
                        name='email'
                        placeholder={messages.inputPlaceholder}
                        maxLength={netSuiteConstants.emailMaxLength}
                    />
                )}

                {isFieldVisible(fieldSettings.phone) && (
                    <TextField
                        label={messages.phone}
                        required={isFieldMandatory(fieldSettings.phone)}
                        name='phone'
                        placeholder={messages.inputPlaceholder}
                        maxLength={netSuiteConstants.phoneMaxLength}
                    />
                )}

                {isFieldVisible(fieldSettings.altPhone) && (
                    <TextField
                        label={messages.altPhone}
                        required={isFieldMandatory(fieldSettings.altPhone)}
                        name='altPhone'
                        placeholder={messages.inputPlaceholder}
                        maxLength={netSuiteConstants.altPhoneMaxLength}
                    />
                )}

                {isFieldVisible(fieldSettings.fax) && (
                    <TextField
                        label={messages.fax}
                        required={isFieldMandatory(fieldSettings.fax)}
                        name='fax'
                        placeholder={messages.inputPlaceholder}
                        maxLength={netSuiteConstants.faxMaxLength}
                    />
                )}
            </Grid>
        </Form.Part>
    );
});

ContactInformation.displayName = 'ContactInformation';
